<template>
  <v-menu
    transition="slide-y-transition"
    left
    bottom
    offset-y
    attach="attach"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :aria-label="$t('app.changeLanguage')"
        text
        v-on="on"
      >
        {{ $i18n.locale }}
        <!-- <v-icon class="ml-1 hidden-sm-and-down">
          mdi-translate
        </v-icon> -->
        <v-icon>
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="language in languages"
        :key="language.locale"
        :to="{ name: $route.name, params: { lang: language.locale } }"
      >
        <v-list-item-title>{{ language.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import languages from '@/languages'

export default {
  name: 'LanguageSelector',
  data: function () {
    return {
      languages
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
